import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { IAuthenticationState } from "../../contracts/IAuthenticationState";
import { IRootState } from "../../reducers";
import Report from "../../components/Report"

interface IHomePageState {
  authState: IAuthenticationState;
}

interface IHomePageProps {
  authState: IAuthenticationState;
}

class HomePage extends React.Component<IHomePageProps, IHomePageState> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const authState = this.props.authState;
    if (!authState.isLoggedIn) {
      return <Redirect to="login" />;
    }
    return <Report />;
  }
}

const mapStateToProps = (state: IRootState, ownProps: any) => ({
  authState: state.authState
});

const connectedLoginPage = connect(mapStateToProps)(HomePage);
export { connectedLoginPage as HomePage };



// WEBPACK FOOTER //
// ./src/scenes/home-page/index.tsx